__turbopack_context__.v({
  "backgroundLayer": "A2VFRW_backgroundLayer",
  "heading": "A2VFRW_heading",
  "line": "A2VFRW_line",
  "section": "A2VFRW_section",
  "textContainer": "A2VFRW_textContainer",
  "vignette": "A2VFRW_vignette",
});
